import React from "react";
import About1 from "./About1";
import Section1 from "./Section1";
import Counter from "./Counter";
import Features from "./Features";
import Cta from "./Cta";
import CompanyTestimonal1 from "./CompanyTestimonal1";

const WhatWeDo = () => {
    document.title = "What We Do - Matrix Executive Search Group";
    return (
        <React.Fragment>
            <Section1 />
            <About1 />
            <Counter />
            <Features />
            <Cta />
            <CompanyTestimonal1 />
        </React.Fragment>
    );
};

export default WhatWeDo;
